import { ErrorCode } from '@blk/wealth-web-endpoint';

export class WwePortfolioAnalysisPartialError {
	constructor(public readonly portfolioNames: string[], public readonly errorCodes: Map<string, ErrorCode>) { }
}
